<nav-menu *ngIf="!isPreview() && labelsService.labelsLoaded()" class="dynamics-content"></nav-menu>


<main role="main" class="dynamics-content" *ngIf="labelsService.labelsLoaded()">
    <router-outlet></router-outlet>
</main>
